import { render } from "./Edit.vue?vue&type=template&id=601ae420&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=601ae420&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601ae420"],['__file',"src/views/CourseRequests/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "601ae420"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('601ae420', __exports__)) {
    api.reload('601ae420', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=601ae420&scoped=true", () => {
    api.rerender('601ae420', render)
  })

}


export default __exports__